<template>
  <div class="loader-feedback">
    <span
      class="loader-feedback__title"
      v-text="translate('scheduler.modal.parameters.data.set.label')"
    />
    <div class="loader-feedback__input">
      <mds-loader size="small" class="loader-feedback__loader" />
      <span
        class="loader-feedback__description"
        v-text="translate('scheduler.input.loading')"
      />
    </div>
  </div>
</template>

<script>
import MdsLoader from '@mds/loader'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/components/schedulerModal/config/i18n'

export default {
  name: 'ComboBoxLoading',
  components: {
    MdsLoader,
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/typography';
@import '@mds/constants';

.loader-feedback {
  &__input {
    height: 29px;
    background: #f5f5f5;
    width: 100%;
    border-bottom: solid 1px $mds-color-neutral-80;
    padding: $mds-space-half-x $mds-space-3-and-a-half-x $mds-space-half-x
      $mds-space-4-x;
    color: #ababab;
    position: relative;
  }

  &__loader {
    padding: 0;
    margin: 0 !important;
    position: absolute;
    top: $mds-space-half-x;
    left: $mds-space-1-x;
    scale: 0.5;
    filter: grayscale(1);
  }

  &__title {
    @include mds-body-text-m();
    display: block;
    font-weight: 600;
    margin-bottom: $mds-space-1-x;
  }
}
</style>
